// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-69ba34dd] .table thead th,[data-v-69ba34dd] .table.b-table > thead > tr > .table-b-table-default,\n.table.b-table > tbody > tr > .table-b-table-default[data-v-69ba34dd],\n.table.b-table > tfoot > tr > .table-b-table-default[data-v-69ba34dd] {\n  background-color: rgb(250 251 252);\n}\n", ""]);
// Exports
module.exports = exports;
